import Banner from "Components/Banner";
import AddUpdateBanner from "Components/Banner/AddUpdate";
import Blog from "Components/Blog";
import AddUpdateBlog from "Components/Blog/AddUpdate";
import BlogCategory from "Components/Blog/Category";
import { default as AddUpdateBlogCategory } from "Components/Blog/Category/AddUpdate";
import BlogSubCategory from "Components/Blog/SubCategory";
import AddUpdateBlogSubCategory from "Components/Blog/SubCategory/AddUpdate";
import CustomerNeed from "Components/Customer/Customer Need";
import CustomerRequirement from "Components/Customer/CustomerRequirement";
import Dashboard from "Components/Dashboard";
import Event from "Components/Event";
import AddUpdateEvent from "Components/Event/AddUpdate";
import FAQ from "Components/FAQ";
import AddUpdateFAQ from "Components/FAQ/AddUpdate";
import MainHeader from "Components/Header/MainHeader";
import SubHeader from "Components/Header/SubHeader";
import SubSubHeader from "Components/Header/SubSubHeader";
import Products from "Components/Inventory/Products";
import LeadManagement from "Components/Lead Management";
import DiractLeadManagement from "Components/Lead Management/DiractLead";
import SellerLeadManagement from "Components/Lead Management/SellerLead";
import MetaPages from "Components/Meta";
import AddMetaPages from "Components/Meta/AddMetaPages";
import MetaDetails from "Components/Meta/Metadetails";
import AddMetaDetails from "Components/Meta/Metadetails/MetaAddDetails";
import News from "Components/News";
import AddUpdateNews from "Components/News/AddUpdate";
import DynamicUIList from "Components/PageDesignSettings";
import AddDynamicUI from "Components/PageDesignSettings/AddPageDesign";
import PlanData from "Components/PlanManagement";
import ModuleManagement from "Components/PlanManagement/ModuleManagement";
import Plan from "Components/PlanManagement/Plan";
import PlanType from "Components/PlanManagement/PlanType";
import Seller from "Components/Seller";
import SellerDetails from "Components/Seller/SellerDetails";
import Slider from "Components/Slider";
import AddUpdateSlider from "Components/Slider/AddUpdate";
import Testimonial from "Components/Testimonial";
import AddUpdateTestimonial from "Components/Testimonial/AddUpdate";
import TradeExhibtion from "Components/Trade/TradeExibition";
import TradeShow from "Components/Trade/TradeShow";

const routes = [
    {
        id: 1,
        path: "/customization",
        component: <MainHeader />,
    },
    {
        id: 2,
        path: "/customization/main-header",
        component: <MainHeader />,
    },
    {
        id: 3,
        path: "/customization/sub-header",
        component: <SubHeader />,
    },
    {
        id: 4,
        path: "/customization/sub-sub-header",
        component: <SubSubHeader />,
    },
    {
        id: 5,
        path: "/",
        component: <Dashboard />
    },
    {
        id: 6,
        path: "/inventory",
        component: <Products />
    },
    {
        id: 7,
        path: "/inventory/products",
        component: <Products />
    },
    {
        id: 8,
        path: "/seller",
        component: <Seller />
    },
    {
        id: 9,
        path: "/seller/:seller_id",
        component: <SellerDetails />
    },
    {
        id: 10,
        path: "/blog",
        component: <Blog />
    },
    {
        id: 11,
        path: "/blog/category",
        component: <BlogCategory />
    },
    {
        id: 12,
        path: "/blog/sub-category",
        component: <BlogSubCategory />
    },
    {
        id: 13,
        path: "/blog/category/:status/:id",
        component: <AddUpdateBlogCategory />
    },
    {
        id: 14,
        path: "/blog/category/:status",
        component: <AddUpdateBlogCategory />
    },
    {
        id: 15,
        path: "/blog/sub-category/:status/:id",
        component: <AddUpdateBlogSubCategory />
    },
    {
        id: 16,
        path: "/blog/sub-category/:status",
        component: <AddUpdateBlogSubCategory />
    },
    {
        id: 17,
        path: "/blog/:status",
        component: <AddUpdateBlog />
    },
    {
        id: 18,
        path: "/blog/:status/:id",
        component: <AddUpdateBlog />
    },
    {
        id: 19,
        path: "/news",
        component: <News />
    },
    {
        id: 20,
        path: "/news/:status",
        component: <AddUpdateNews />
    },
    {
        id: 21,
        path: "/news/:status/:id",
        component: <AddUpdateNews />
    },
    {
        id: 22,
        path: "/faq/:status/:id",
        component: <AddUpdateFAQ />
    },
    {
        id: 23,
        path: "/faq/:status",
        component: <AddUpdateFAQ />
    },
    {
        id: 24,
        path: "/faq",
        component: <FAQ />
    },
    {
        id: 25,
        path: "/slider/:status/:id",
        component: <AddUpdateSlider />
    },
    {
        id: 26,
        path: "/slider/:status",
        component: <AddUpdateSlider />
    },
    {
        id: 27,
        path: "/slider",
        component: <Slider />
    },
    {
        id: 25,
        path: "/banner/:status/:id",
        component: <AddUpdateBanner />
    },
    {
        id: 26,
        path: "/banner/:status",
        component: <AddUpdateBanner />
    },
    {
        id: 27,
        path: "/banner",
        component: <Banner />
    },
    {
        id: 28,
        path: "/event",
        component: <Event />
    },
    {
        id: 29,
        path: "/event/:status/:id",
        component: <AddUpdateEvent />
    },
    {
        id: 30,
        path: "/event/:status",
        component: <AddUpdateEvent />

    },


    {
        id: 31,
        path: "/testimonial",
        component: <Testimonial />

    },

    {
        id: 32,
        path: "/testimonial/:status/:id",
        component: <AddUpdateTestimonial />
    },

    {
        id: 33,
        path: "/testimonial/:status",
        component: <AddUpdateTestimonial />
    },



    {
        id: 34,
        path: "plan-management/plantype",
        component: <PlanType />
    },



    {
        id: 35,
        path: "plan-management/module",
        component: <ModuleManagement />
    },

    {
        id: 36,
        path: "plan-management",
        component: <PlanData />
    },

    {
        id: 37,
        path: "plan-management/plan",
        component: <Plan />
    },


    {
        id: 38,
        path: "lead-management/direct",
        component: <DiractLeadManagement />
    },

    {
        id: 39,
        path: "lead-management",
        component: <LeadManagement />
    },


    {
        id: 39,
        path: "lead-management/seller",
        component: <SellerLeadManagement />
    },

    {
        id: 40,
        path: "customer-need",
        component: <CustomerNeed />
    },

    {
        id: 41,
        path: "tradeshow",
        component: <TradeShow />
    },

    {
        id: 41,
        path: "exhibition",
        component: <TradeExhibtion />
    },



    {
        id: 43,
        path: "customer-need/requirement",
        component: <CustomerRequirement />
    },

    {
        id: 44,
        path: "meta",
        component: <MetaPages />
    },
    {
        id: 45,
        path: "meta/:type",
        component: <AddMetaPages />


    },

    {
        id: 45,
        path: "metadetails/:id",
        component: <MetaDetails />


    },

    {
        id: 45,
        path: "metadetails/:id/:type",
        component: <AddMetaDetails />


    },

    {
        id: 46,
        path: "page-design",
        component: <DynamicUIList />


    },

    {
        id: 47,
        path: "page-design/:type",
        component: <AddDynamicUI />


    },






















]

export default routes;